import React, { useContext, useState, useEffect } from "react";
import { Form, Modal } from "react-bootstrap";
import "../../../CommonCss/ModalCommonCss.css";
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import EditLottieModal from "../../../commonLottie/EditLottieModal";
import { Context } from "../../../../../utils/context";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import Select from "react-select";
import AddAssitModal from "./AddAssitModal";
import AddedLottieModal from "../../../commonLottie/AddedLottieModal";

const AddModal = (props) => {
  const [showLottie, setShowLottie] = useState({
    show: false,
    msg: "",
    success: false,
  });
  const [showAddAsset, setShowAddAsset] = useState(false);

  const { postData, getData, Select2Data } = useContext(Context);
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    control,
    watch,
    formState: { errors },
    getValues,
  } = useForm();

  const [departments, setDepartments] = useState([]);
  const [users, setUsers] = useState([]);
  const [assets, setAssets] = useState([]);

  const DepartmentId = getValues("department_id");

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();
      sendData.append("department_id", data?.department_id?.value);
      sendData.append("employee_id", data?.employee_id?.value);
      data?.asset_id.forEach((asset) =>
        sendData.append("asset_id", asset.value),
      );

      const response = await postData(`/hrms/assign-asset`, sendData);
      if (response?.success) {
        setShowLottie({
          show: true,
          msg: response?.message,
          success: response?.success,
        });
        reset();
      } else {
        setShowLottie({
          show: true,
          msg: response?.message,
          success: response?.success,
        });
      }
      setTimeout(() => {
        setShowLottie({ show: false, msg: "", success: false });
        props?.onHide();
      }, 1000);
    } catch (error) {
      console.error(error);
    }
  };

  const getDepartments = async () => {
    const response = await getData("/masters/alldepartments");
    if (response?.success) {
      setDepartments(await Select2Data(response?.data, "leave_type_id"));
    }
  };

  const getEmployees = async (id) => {
    const response = await getData(`/masters/allemployeebydept/${id}`);
    if (response?.success) {
      setUsers(await Select2Data(response?.data, "employee_id"));
    }
  };

  const getShifts = async () => {
    const response = await getData("/hrms-masters/all-assets");
    if (response?.success) {
      setAssets(await Select2Data(response?.data, "asset_id"));
    }
  };

  console.log(getValues("department_id"), "getValues");

  useEffect(() => {
    getDepartments();
    getShifts();
  }, []);

  useEffect(() => {
    getEmployees(DepartmentId?.value);
  }, [DepartmentId?.value]);

  return (
    <section className="modal-common-class-hrms">
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="add-modal">
        <Modal.Body>
          <div className="text-center">
            <h4 className="modal-title-common">Assign Assets</h4>
          </div>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <div className="below-bodyy">
              <div>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1">
                  <Form.Label>Department</Form.Label>
                  <Controller
                    name="department_id"
                    {...register("department_id", {
                      required: "Select Department",
                    })}
                    control={control}
                    rules={{
                      required: "Select Department",
                    }}
                    render={({ field: { onChange, onBlur, value, ref } }) => (
                      <Select
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            borderColor: errors?.department_id
                              ? "red"
                              : baseStyles.borderColor,
                          }),
                        }}
                        options={departments}
                        onChange={(item) => {
                          setValue("department_id", item);
                          getEmployees(item?.value);
                          setValue("employee_id", "");
                        }}
                      />
                    )}
                  />
                  {errors?.department_id && (
                    <span className="text-danger">
                      {errors?.department_id.message}
                    </span>
                  )}
                </Form.Group>
              </div>
              <div>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1">
                  <Form.Label>Employee</Form.Label>
                  <Controller
                    name="employee_id" // name of the field
                    {...register("employee_id", {
                      required: "Select Employee",
                    })}
                    control={control}
                    render={({ field }) => (
                      <Select
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            borderColor: errors.employee_id
                              ? "red"
                              : baseStyles,
                          }),
                        }}
                        {...field}
                        options={users}
                      />
                    )}
                  />

                  {errors?.employee_id && (
                    <span className="text-danger">
                      {errors?.employee_id.message}
                    </span>
                  )}
                </Form.Group>
              </div>
              <div>
                <Form.Group className="mb-3" controlId="assignedAssets">
                  <Form.Label>Assigned Assets</Form.Label>
                  <Controller
                    name="asset_id" // name of the field
                    {...register("asset_id", {
                      required: "Select Assets",
                    })}
                    control={control}
                    render={({ field }) => (
                      <Select
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            borderColor: errors.asset_id ? "red" : baseStyles,
                          }),
                        }}
                        {...field}
                        options={assets}
                        isMulti
                      />
                    )}
                  />

                  {errors?.asset_id && (
                    <span className="text-danger">
                      {errors?.asset_id.message}
                    </span>
                  )}

                  {/* Wrapper for label */}
                  <div
                    className="text-end"
                    onClick={() => {
                      setShowAddAsset(true);
                    }}>
                    <label className="assign-more mt-1">
                      Add New Assets
                      <FontAwesomeIcon className="ms-3" icon={faCirclePlus} />
                    </label>
                  </div>
                </Form.Group>
              </div>

              <div className="text-center mt-5 mb-5">
                <button
                  className="cancel-button me-2"
                  type="button"
                  onClick={() => {
                    props.onHide();
                    reset();
                  }}>
                  Cancel
                </button>
                <button className="save-button" type="submit">
                  Save
                </button>
              </div>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <AddedLottieModal
        pageTitle="Designation"
        message={showLottie.msg}
        show={showLottie.show}
        success={showLottie.success}
        onHide={() => setShowLottie({ show: false, msg: "", success: false })}
      />

      <AddAssitModal
        show={showAddAsset}
        onHide={() => {
          setShowAddAsset(false);
          getShifts();
        }}
      />
    </section>
  );
};

export default AddModal;
